import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/hub/src/components/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
